"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserListItemDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../../enums");
const Venue_dto_1 = require("../Venue.dto");
const Visit_dto_1 = require("../Visit.dto");
class UserListItemDto {
  constructor() {
    this.visits = [];
  }
}
exports.UserListItemDto = UserListItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "lastActiveAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserListItemDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserListItemDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user photo passed Ivy photo verification.'
}), __metadata("design:type", Boolean)], UserListItemDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UserListItemDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserListItemDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserListItemDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Venue_dto_1.VenueDto)], UserListItemDto.prototype, "currentVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserListItemDto.prototype, "currentVenueCheckedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserListItemDto.prototype, "secondsInVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: Visit_dto_1.VisitDto,
  isArray: true
}), __metadata("design:type", Array)], UserListItemDto.prototype, "visits", void 0);
//# sourceMappingURL=UserListItem.dto.js.map